// extracted by mini-css-extract-plugin
export default {"formattedAmount":"formattedAmount_c29e2"};